import { Dropdown } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { useState } from 'react';
import TopsideNote from '../topsideNote/topsideNote';
import SignKitColorSelector from '../signKitColorSelector/SignKitColorSelector';
import ExportToPdf from '../exportToPdf/ExportToPdf';
import ChainInventoryToggle from '../chainInventoryToggle/ChainInventoryToggle';
import appConfig from '../../config/config.json';
import { useLocation } from 'react-router-dom';
import './HeaderMenu.css';

interface HeaderMenuProps {
  store: string;
  effectiveDate: Date;
}

const HeaderMenu = ({ store, effectiveDate }: HeaderMenuProps) => {
  const [showTopsideNote, setShowTopsideNote] = useState(false);
  const [showColorSelector, setShowColorSelector] = useState(false);
  const location = useLocation();

  const handleMenuClick = (key: string) => {
    switch (key) {
      case 'topsideNote':
        setShowTopsideNote(true);
        break;
      case 'colorSelector':
        setShowColorSelector(true);
        break;
      default:
        break;
    }
  };

  const menuItems = [
    {
      key: 'topsideNote',
      label: (
        <div className="header-menu-item">
          <TopsideNote />
        </div>
      ),
    },
    {
      key: 'chainInventory',
      label: (
        <div className="header-menu-item">
          <ChainInventoryToggle />
        </div>
      ),
    },
  ];

  if (appConfig.showColorSelect) {
    menuItems.push({
      key: 'colorSelector',
      label: (
        <div className="header-menu-item">
          <SignKitColorSelector />
        </div>
      ),
    });
  }

  if (location.pathname === '/') {
    menuItems.push({
      key: 'exportPdf',
      label: (
        <div className="header-menu-item">
          <ExportToPdf store={store} effectiveDate={effectiveDate} />
        </div>
      ),
    });
  }

  const menu = {
    onClick: ({ key }: { key: string }) => handleMenuClick(key),
    items: menuItems,
  };

  return (
    <Dropdown 
      menu={menu} 
      trigger={['click']} 
      placement="bottomRight"
      overlayClassName="header-menu-dropdown"
      align={{ offset: [40, 8] }}
    >
      <div className="header-menu-trigger">
        <MenuOutlined />
      </div>
    </Dropdown>
  );
};

export default HeaderMenu;
